import { OrgPermission } from '../../../backend/src/organisation/organisation-permission';
import { useUserContext } from '@/Contexts/User';

export const useOrgPermissions = () => {
  const { user } = useUserContext();
  const permissions = user?.organisation?.permissions ?? [];

  const hasOrgPermission = (permission: OrgPermission) => permissions.includes(permission);

  return {
    isEnabled: hasOrgPermission,
  };
};
